import { Reveal } from "./Reveal";

export default function SectionHeading({ eyebrow, title, sub, center = false }) {
  return (
    <div className={center ? "text-center" : ""}>
      <Reveal>
        <p className={`flex items-center gap-3 font-mono text-xs tracking-[0.35em] text-accent ${center ? "justify-center" : ""}`}>
          <span className="h-px w-10 bg-accent" />
          {eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.06}>
        <h2 className="mt-5 font-mincho text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.12}>
          <p className={`mt-5 max-w-2xl text-sm leading-relaxed text-gray-400 sm:text-base ${center ? "mx-auto" : ""}`}>{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
